import React from 'react';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { StepIndicator, StepIndicatorStates } from 'components/StepIndicator';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';

interface StepTitleProps {
  number: number,
  activeTitle: string,
  incompleteTitle: string,
  completedTitle: string,
  state: StepIndicatorStates,
  onHelpClick?: () => void
  onEditClick?: () => void
}

export const StepTitle: React.FC<StepTitleProps> = (props: StepTitleProps) => {
  const { formatMessage } = useIntl();

  const renderTitle = () => {
    switch (props.state) {
      case 'active':
        return props.activeTitle;
      case 'complete':
        return props.completedTitle;
      default:
        return props.incompleteTitle;
    }
  };

  return (
    <Stack direction='row' alignItems={props.state === 'active' ? 'start' : 'center'} flexGrow={1} gap={2} >
      <StepIndicator number={props.number} state={props.state} />
      <Typography
        variant={props.state === 'active' ? 'h4' : 'h5'}
        fontWeight={props.state === 'active' ? undefined : 500}
        color={props.state === 'incomplete' ? 'text.secondary' : 'text.primary'}
      >
        {renderTitle()}
      </Typography>
      {props.state === 'active' && props.onHelpClick && (
        <IconButton aria-label="help" onClick={props.onHelpClick}>
          <HelpOutlineIcon fontSize='small' />
        </IconButton>
      )}
      {props.state === 'complete' && props.onEditClick && (
        <Stack direction='row' flexGrow={1} alignItems='center' justifyContent='flex-end'>
          <Button variant='text' onClick={props.onEditClick}>{formatMessage(commonMessages.edit)}</Button>
        </Stack>
      )}
    </Stack>
  );
};